import React from "react";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export default function AttachMoney(props) {
  return (
    <AttachMoneyIcon 
    style={{ fill: '#0198E1' , margin: '0 0 0 0'}} 
    sx={{ color: 'action.active', mr: 1, my: 1, fontSize: 60}} />
  );
}